import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from '../BaseApi';
import {
    CreateCafeteria,
    GetDepartmentsByCafeteriaId, GetUsersByCafeteriaId,
    UpdateCafeteria
} from './CafeteriaApi';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const CafeteriaSlice = createSlice({
    name: "cafeteria",
    initialState: {
        createCafeteria: null,
        updateCafeteria: null,
        getDepartmentsByCafeteriaId: [],
        getUsersByCafeteriaId:[]
    },
    reducers: {
        resetMeasurementUnitsAll: (state, action) => {
            state.measurementUnitsAll = null;
        }
    },
    extraReducers: (builder) => {
        builder.
        addCase(CreateCafeteria.fulfilled, (state, {payload}) =>{
            state.createCafeteria = ResponseApi(payload);
        }).addCase(UpdateCafeteria.fulfilled, (state, {payload}) =>{
            state.updateCafeteria = ResponseApi(payload);
        }).addCase(GetDepartmentsByCafeteriaId.fulfilled, (state, {payload}) =>{
            state.getDepartmentsByCafeteriaId = ResponseApi(payload);
        }).addCase(GetUsersByCafeteriaId.fulfilled, (state, {payload}) =>{
            state.getUsersByCafeteriaId = ResponseApi(payload);
        })
    }

})

export const { } = CafeteriaSlice.actions;

export default CafeteriaSlice.reducer;
